const backend_url = String(process.env.REACT_APP_API_BASE_URL);

// Authentication URLs
export const login_api_url = `${backend_url}/auth/login`;
export const auth_data_api_url = `${backend_url}/auth/data`;

// Campaigns URLs
export const campaigns_api_url = `${backend_url}/campaigns/generate-ai-brief`;

// Users URLs
export const users_list_api_url = `${backend_url}/users/fetch`;
export const users_trash_api_url = `${backend_url}/users/fetch/trashed`;
export const create_user_api_url = `${backend_url}/users/create`;
export const update_user_api_url = `${backend_url}/users/update`;
export const delete_user_api_url = `${backend_url}/users/delete`;
export const destroy_user_api_url = `${backend_url}/users/destroy`;
export const restore_user_api_url = `${backend_url}/users/restore`;
export const multiple_delete_user_api_url = `${backend_url}/users/bulk-delete`;
export const multiple_destroy_user_api_url = `${backend_url}/users/bulk-destroy`;
export const multiple_restore_user_api_url = `${backend_url}/users/bulk-restore`;
export const user_details_api_url = `${backend_url}/users/fetch`;

// Roles URLs
export const roles_list_api_url = `${backend_url}/roles/fetch`;
export const roles_without_pagination = `${backend_url}/roles/fetch/all`;
export const roles_trash_api_url = `${backend_url}/roles/fetch/trashed`;
export const create_role_api_url = `${backend_url}/roles/create`;
export const update_role_api_url = `${backend_url}/roles/update`;
export const delete_role_api_url = `${backend_url}/roles/delete`;
export const destroy_role_api_url = `${backend_url}/roles/destroy`;
export const restore_role_api_url = `${backend_url}/roles/restore`;
export const multiple_delete_role_api_url = `${backend_url}/roles/bulk-delete`;
export const multiple_destroy_role_api_url = `${backend_url}/roles/bulk-destroy`;
export const multiple_restore_role_api_url = `${backend_url}/roles/bulk-restore`;

// Permissions URLs
export const permissions_json_api_url = `${backend_url}/permissions/fetch`;
export const assign_permissions_api_url = `${backend_url}/permissions/assign`;
export const check_permissions_api_url = `${backend_url}/permissions/check-permissions`;

// Brand URLs
export const brands_list_api_url = `${backend_url}/brands/fetch`;
export const brands_all_api_url = `${backend_url}/brands/fetch/all`;
export const brands_trash_api_url = `${backend_url}/brands/fetch/trashed`;
export const create_brand_api_url = `${backend_url}/brands/create`;
export const update_brand_api_url = `${backend_url}/brands/update`;
export const delete_brand_api_url = `${backend_url}/brands/delete`;
export const destroy_brand_api_url = `${backend_url}/brands/destroy`;
export const restore_brand_api_url = `${backend_url}/brands/restore`;
export const multiple_delete_brand_api_url = `${backend_url}/brands/bulk-delete`;
export const multiple_destroy_brand_api_url = `${backend_url}/brands/bulk-destroy`;
export const brand_details_api_url = `${backend_url}/brands/fetch`;
export const brand_status_api_url = `${backend_url}/brands/status`;

// Category URLs
export const categories_list_api_url = `${backend_url}/categories/fetch`;
export const categories_all_api_url = `${backend_url}/categories/fetch/all`;
export const categories_trash_api_url = `${backend_url}/categories/fetch/trashed`;
export const create_category_api_url = `${backend_url}/categories/create`;
export const update_category_api_url = `${backend_url}/categories/update`;
export const delete_category_api_url = `${backend_url}/categories/delete`;
export const destroy_category_api_url = `${backend_url}/categories/destroy`;
export const restore_category_api_url = `${backend_url}/categories/restore`;
export const multiple_delete_category_api_url = `${backend_url}/categories/bulk-delete`;
export const multiple_destroy_category_api_url = `${backend_url}/categories/bulk-destroy`;
export const category_details_api_url = `${backend_url}/categories/fetch`;
export const category_status_api_url = `${backend_url}/categories/status`;

// Product Sub Category URLs
export const product_sub_categories_list_api_url = `${backend_url}/sub/categories/fetch`;
export const product_sub_categories_all_api_url = `${backend_url}/sub/categories/fetch/all`;
export const product_sub_categories_trash_api_url = `${backend_url}/sub/categories/fetch/trashed`;
export const create_product_sub_category_api_url = `${backend_url}/sub/categories/create`;
export const update_product_sub_category_api_url = `${backend_url}/sub/categories/update`;
export const delete_product_sub_category_api_url = `${backend_url}/sub/categories/delete`;
export const destroy_product_sub_category_api_url = `${backend_url}/sub/categories/destroy`;
export const restore_product_sub_category_api_url = `${backend_url}/sub/categories/restore`;
export const multiple_delete_product_sub_category_api_url = `${backend_url}/sub/categories/bulk-delete`;
export const multiple_destroy_product_sub_category_api_url = `${backend_url}/sub/categories/bulk-destroy`;
export const product_sub_category_details_api_url = `${backend_url}/sub/categories/fetch`;
export const product_sub_category_status_api_url = `${backend_url}/sub/categories/status`;

// Product URLs
export const products_list_api_url = `${backend_url}/products/fetch`;
export const products_all_api_url = `${backend_url}/products/fetch/all`;
export const products_trash_api_url = `${backend_url}/products/fetch/trashed`;
export const create_product_api_url = `${backend_url}/products/create`;
export const update_product_api_url = `${backend_url}/products/update`;
export const delete_product_api_url = `${backend_url}/products/delete`;
export const destroy_product_api_url = `${backend_url}/products/destroy`;
export const restore_product_api_url = `${backend_url}/products/restore`;
export const multiple_delete_product_api_url = `${backend_url}/products/bulk-delete`;
export const multiple_destroy_product_api_url = `${backend_url}/products/bulk-destroy`;
export const product_details_api_url = `${backend_url}/products/fetch`;
export const product_status_api_url = `${backend_url}/products/status`;
export const product_excel_template = `${backend_url}/products/export/excel/template`;
// Banner URLs
export const banners_list_api_url = `${backend_url}/banners/fetch`;
export const banners_all_api_url = `${backend_url}/banners/fetch/all`;
export const banners_trash_api_url = `${backend_url}/banners/fetch/trashed`;
export const create_banner_api_url = `${backend_url}/banners/create`;
export const update_banner_api_url = `${backend_url}/banners/update`;
export const delete_banner_api_url = `${backend_url}/banners/delete`;
export const destroy_banner_api_url = `${backend_url}/banners/destroy`;
export const restore_banner_api_url = `${backend_url}/banners/restore`;
export const multiple_delete_banner_api_url = `${backend_url}/banners/bulk-delete`;
export const multiple_destroy_banner_api_url = `${backend_url}/banners/bulk-destroy`;
export const banner_details_api_url = `${backend_url}/banners/fetch`;
export const banner_status_api_url = `${backend_url}/banners/status`;

// Blog Category URLs
export const blog_categories_list_api_url = `${backend_url}/blog/categories/fetch`;
export const blog_categories_all_api_url = `${backend_url}/blog/categories/fetch/all`;
export const blog_categories_trash_api_url = `${backend_url}/blog/categories/fetch/trashed`;
export const create_blog_category_api_url = `${backend_url}/blog/categories/create`;
export const update_blog_category_api_url = `${backend_url}/blog/categories/update`;
export const delete_blog_category_api_url = `${backend_url}/blog/categories/delete`;
export const destroy_blog_category_api_url = `${backend_url}/blog/categories/destroy`;
export const restore_blog_category_api_url = `${backend_url}/blog/categories/restore`;
export const multiple_delete_blog_category_api_url = `${backend_url}/blog/categories/bulk-delete`;
export const multiple_destroy_blog_category_api_url = `${backend_url}/blog/categories/bulk-destroy`;
export const blog_category_details_api_url = `${backend_url}/blog/categories/fetch`;
export const blog_category_status_api_url = `${backend_url}/blog/categories/status`;

// Blog URLs
export const blogs_list_api_url = `${backend_url}/blogs/fetch`;
export const blogs_all_api_url = `${backend_url}/blogs/fetch/all`;
export const blogs_trash_api_url = `${backend_url}/blogs/fetch/trashed`;
export const create_blog_api_url = `${backend_url}/blogs/create`;
export const update_blog_api_url = `${backend_url}/blogs/update`;
export const delete_blog_api_url = `${backend_url}/blogs/delete`;
export const destroy_blog_api_url = `${backend_url}/blogs/destroy`;
export const restore_blog_api_url = `${backend_url}/blogs/restore`;
export const multiple_delete_blog_api_url = `${backend_url}/blogs/bulk-delete`;
export const multiple_destroy_blog_api_url = `${backend_url}/blogs/bulk-destroy`;
export const blog_details_api_url = `${backend_url}/blogs/fetch`;
export const blog_status_api_url = `${backend_url}/blogs/status`;

// Social Link URLs
export const social_links_list_api_url = `${backend_url}/social-links/fetch`;
export const social_links_all_api_url = `${backend_url}/social-links/fetch/all`;
export const social_links_trash_api_url = `${backend_url}/social-links/fetch/trashed`;
export const create_social_link_api_url = `${backend_url}/social-links/create`;
export const update_social_link_api_url = `${backend_url}/social-links/update`;
export const delete_social_link_api_url = `${backend_url}/social-links/delete`;
export const destroy_social_link_api_url = `${backend_url}/social-links/destroy`;
export const restore_social_link_api_url = `${backend_url}/social-links/restore`;
export const multiple_delete_social_link_api_url = `${backend_url}/social-links/bulk-delete`;
export const multiple_destroy_social_link_api_url = `${backend_url}/social-links/bulk-destroy`;
export const social_link_details_api_url = `${backend_url}/social-links/fetch`;
export const social_link_status_api_url = `${backend_url}/social-links/status`;

// Contact Messages URLs
export const contact_messages_send_api_url = `${backend_url}/contacts/send`;
export const contact_messages_list_api_url = `${backend_url}/contacts/fetch`;
export const contact_messages_all_api_url = `${backend_url}/contacts/fetch/all`;
export const contact_messages_trash_api_url = `${backend_url}/contacts/fetch/trashed`;
export const reply_contact_message_api_url = `${backend_url}/contacts/reply`;
export const delete_contact_message_api_url = `${backend_url}/contacts/delete`;
export const destroy_contact_message_api_url = `${backend_url}/contacts/destroy`;
export const restore_contact_message_api_url = `${backend_url}/contacts/restore`;
export const multiple_delete_contact_message_api_url = `${backend_url}/contacts/bulk-delete`;
export const multiple_destroy_contact_message_api_url = `${backend_url}/contacts/bulk-destroy`;

// Contact Setting URLs
export const contact_settings_list_api_url = `${backend_url}/contact-settings/fetch`;
export const contact_settings_all_api_url = `${backend_url}/contact-settings/fetch/all`;
export const contact_settings_trash_api_url = `${backend_url}/contact-settings/fetch/trashed`;
export const contact_settings_latest_api_url = `${backend_url}/contact-settings/fetch/latest`;
export const create_contact_setting_api_url = `${backend_url}/contact-settings/create`;
export const update_contact_setting_api_url = `${backend_url}/contact-settings/update`;
export const delete_contact_setting_api_url = `${backend_url}/contact-settings/delete`;
export const destroy_contact_setting_api_url = `${backend_url}/contact-settings/destroy`;
export const restore_contact_setting_api_url = `${backend_url}/contact-settings/restore`;
export const multiple_delete_contact_setting_api_url = `${backend_url}/contact-settings/bulk-delete`;
export const multiple_destroy_contact_setting_api_url = `${backend_url}/contact-settings/bulk-destroy`;
export const contact_setting_details_api_url = `${backend_url}/contact-settings/fetch`;
export const contact_setting_status_api_url = `${backend_url}/contact-settings/status`;

// Page Meta URLs
export const page_meta_list_api_url = `${backend_url}/page-meta/fetch`;
export const page_meta_all_api_url = `${backend_url}/page-meta/fetch/all`;
export const page_meta_trash_api_url = `${backend_url}/page-meta/fetch/trashed`;
export const create_page_meta_api_url = `${backend_url}/page-meta/create`;
export const update_page_meta_api_url = `${backend_url}/page-meta/update`;
export const delete_page_meta_api_url = `${backend_url}/page-meta/delete`;
export const destroy_page_meta_api_url = `${backend_url}/page-meta/destroy`;
export const restore_page_meta_api_url = `${backend_url}/page-meta/restore`;
export const multiple_delete_page_meta_api_url = `${backend_url}/page-meta/bulk-delete`;
export const multiple_destroy_page_meta_api_url = `${backend_url}/page-meta/bulk-destroy`;
export const page_meta_details_api_url = `${backend_url}/page-meta/fetch`;
export const page_meta_status_api_url = `${backend_url}/page-meta/status`;

// Website Setting URLs
export const website_setting_latest_api_url = `${backend_url}/settings/fetch/latest`;
export const website_setting_save_api_url = `${backend_url}/settings/save`;

// SMTP Config URLs
export const smtp_config_latest_api_url = `${backend_url}/smtp-config/fetch/latest`;
export const smtp_config_save_api_url = `${backend_url}/smtp-config/save`;

// Subscribers URLs
export const subscribers_list_api_url = `${backend_url}/subscribers/fetch`;
export const subscribers_trash_api_url = `${backend_url}/subscribers/fetch/trashed`;
export const delete_subscriber_api_url = `${backend_url}/subscribers/delete`;
export const destroy_subscriber_api_url = `${backend_url}/subscribers/destroy`;
export const multiple_delete_subscriber_api_url = `${backend_url}/subscribers/bulk-delete`;
